import { handleRetrieveAllWebinars } from "../../../../redux/admin-slices/webinars.slice"
import { DELETE_WEBINAR, UPDATE_WEBINAR, UPDATE_WEBINAR_STATUS } from "../../../../utils/keywords"
import { showDialogWithData } from "../../../../redux/guest-slices/other.slice"
import TablePagination from "../../../../components/common/PaginationSkell"
import EntriesSelect from "../../../../components/ui/EntriesSelect"
import SelectInputA from "../../../../components/ui/SelectInputA"
import TableSkell from "../../../../components/common/TableSkell"
import InputFieldA from "../../../../components/ui/InputFieldA"
import SelectInput from "../../../../components/ui/SelectInput"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useRef, useState } from "react"
import { Link as NavLink, useParams } from "react-router-dom"
import { debounce } from "../../../../utils/helper"
import Icons from "../../../../assets/js/Icons"
import moment from "moment"

import {
  Box, Button, Container, Grid2 as Grid, IconButton, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Typography
} from "@mui/material"

function AllWebinars() {
  const { type } = useParams()
  const searchRef = useRef("")
  const statusRef = useRef("")
  const entriesRef = useRef("")
  const dispatch = useDispatch()
  const webinarStatusRef = useRef("")
  const [data, setData] = useState({})
  const { refresh, loadings } = useSelector(state => state.otherSlice)

  // handle delete webinar
  const handleDelete = (webinarId) => {
    dispatch(showDialogWithData({ type: DELETE_WEBINAR, data: { webinarId } }))
  }

  // handle update webinar
  const handleUpdate = (webinar) => {
    dispatch(showDialogWithData({ type: UPDATE_WEBINAR, data: { webinar } }))
  }

  // handle update webinar status
  const handleStatus = (webinarId) => {
    dispatch(showDialogWithData({
      type: UPDATE_WEBINAR_STATUS,
      data: { webinarId, status: webinarStatusRef?.current?.value?.value }
    }))
  }

  // Handle retrieve all webinars
  const handleRetrieveAll = (filters) => {
    dispatch(handleRetrieveAllWebinars({
      type,
      search: searchRef?.current?.value || null,
      limit: entriesRef?.current?.value || null,
      currentPage: filters?.currentPage || null,
      status: statusRef?.current?.value?.value || null,
    })
    ).unwrap().then((data) => {
      setData(data)
    }).catch(() => { })
  }

  // Handle search webinars
  const handleSearch = debounce(() => {
    handleRetrieveAll()
  }, 1000)

  useEffect(() => {
    handleRetrieveAll()

    // eslint-disable-next-line
  }, [refresh, type])

  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box className="overview-container">
        <Typography variant="pageTitle">Webinars</Typography>
      </Box>

      <Box className="page-menus">
        {["all", "past", "ongoing", "upcoming"]?.map((element, i) => (
          <Button
            disableRipple
            LinkComponent={NavLink}
            to={`/webinar/${element}`}
            key={`${element}-${i + 1}`}
            sx={{
              textTransform: "capitalize",
              bgcolor: "transparent !important",
              color: type === element ?
                "primary.main" : "other.color1"
            }}
          >{element}
          </Button>
        ))
        }
      </Box>

      <Grid container spacing={1} className="filters-grid" justifyContent="space-between">
        <Grid size={{ xs: 12, lg: "auto" }} sx={{ minWidth: { xl: 350 } }}>
          <InputFieldA
            label="Search"
            ref={searchRef}
            onChangeFun={handleSearch}
            placeholder="Search with titles"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <EntriesSelect
            inputRef={entriesRef}
            label="Entries per page"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <SelectInput
            inputRef={statusRef}
            label="Approval type"
            renderValueKey="name"
            disabledInitial={false}
            selectLabel="Select a value"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
            options={[
              { name: "Pending", value: "pending" },
              { name: "Approved", value: "approved" },
              { name: "Request Revisions", value: "rejected" },
            ]}
          />
        </Grid>
      </Grid>

      <Box className="content-listing">
        <TableContainer className="adminTable1">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {["Title", "Specialist", "Date", "Status", "Action"]?.map((cell, i) => (
                  <TableCell key={i} align="left">{cell}</TableCell>
                ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {loadings?.retrieveAll ?
                <TableSkell colLength={5} /> :
                data?.records?.map((element, i) => (
                  <TableRow
                    key={i}
                    tabIndex={-1}
                    role="checkbox"
                    sx={{ "td": { borderBottomWidth: i === (data?.records?.length - 1) ? "0" : "1px" } }}
                  >
                    <TableCell sx={{ textTransform: "capitalize" }}>{element?.details?.title}</TableCell>
                    <TableCell sx={{ textTransform: "capitalize" }}>{element?.user?.fullName}</TableCell>
                    <TableCell>{moment(element?.schedule?.startTime).format("YYYY-MM-DD")}</TableCell>
                    <TableCell>
                      <SelectInputA
                        renderValueKey="name"
                        value={element?.status}
                        inputRef={webinarStatusRef}
                        loading={loadings?.retrieveAll}
                        key={`${element?._id}-${element?.status}`}
                        onChange={() => {
                          setTimeout(() => {
                            handleStatus(element?._id)
                          }, 0)
                        }}
                        options={[
                          { name: "Pending", value: "pending" },
                          { name: "Approved", value: "approved" },
                          { name: "Request Revisions", value: "rejected" },
                        ]}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        LinkComponent={NavLink}
                        to={`/webinar/view/${element?._id}`}
                        sx={{ svg: { fontSize: 20 }, mr: 0.5 }}
                      >
                        <Icons.ViewSolidSharp />
                      </IconButton>
                      <IconButton
                        size="small"
                        sx={{ mr: 0.5 }}
                        onClick={() => { handleUpdate(element) }}
                      >
                        <Icons.EditSolid />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => { handleDelete(element?._id) }}
                      >
                        <Icons.DeleteSolid />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              }

              {(!data?.records?.length && !loadings?.retrieveAll) &&
                <TableRow sx={{ "td": { borderBottom: "none" } }}>
                  <TableCell colSpan={5}>
                    <Typography variant="noRecords">No results found!</Typography>
                  </TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          cb={handleRetrieveAll}
          pagination={data?.pagination}
          length={data?.records?.length}
          loading={loadings?.retrieveAll}
        />
      </Box>
    </Container>
  )
}

export default AllWebinars